import clsx from 'clsx'
import React, { FC, useEffect } from 'react'

import SvgAngleRight from '@Assets/SVG/AngleRight'
import SVGCheck from '@Assets/SVG/Check'
import { AccordionV2, useAccordionActions } from '@Components/CMS/AccordionV2/AccordionV2'
import { SVGIcon } from '@Components/Icons'
import { ProductSorting } from '@Globals/Algolia/Types'
import { useTranslation } from '@Globals/Translations'

import styles from './SortingAccordion.module.scss'

export interface SortingAccordionProps {
  getSortLabel: (sortKey: ProductSorting) => string
  sort: (sortKey: ProductSorting) => void
  sorting: ProductSorting
}

export const SortingAccordion: FC<SortingAccordionProps> = ({
  getSortLabel,
  sort,
  sorting,
}) => {
  const { t } = useTranslation()
  const accordionActions = useAccordionActions()
  const currentSorting = sorting as ProductSorting

  useEffect(() => {
    const autoClose = () => {
      if (typeof document !== 'undefined') {
        const input = document.getElementById('sort-by-filter')
        if (input && 'checked' in input && input.checked) {
          input.click()
        }
      }
    }
    if (typeof document !== 'undefined') {
      document.addEventListener('click', autoClose)
    }
    return () => document.removeEventListener('click', autoClose)
  }, [])

  return (
    <AccordionV2
      backdrop
      className={styles.sortByAccordion}
      id="sort-by-filter"
      ref={accordionActions}
      trigger={(
        <div className={styles.sortByTrigger}>
          <h3 className={clsx(styles.headerMobile, styles.header)}>{t('products:FILTER_SORT_BY_LABEL').replace(':', '')}</h3>
          <h3 className={clsx(styles.headerDekstop, styles.header)}>{t('products:FILTER_SORT_BY_LABEL')}</h3>
          <div className={styles.subHeaderWrapper}>
            <h3 className={styles.subHeader}>{t(getSortLabel(currentSorting))}</h3>
            <SVGIcon icon={SvgAngleRight} size="16px" />
          </div>
        </div>
      )}
    >
      <div className={styles.sortByContent}>
        {Object.values(ProductSorting)
          .map(key => (
            <button
              key={key}
              className={clsx(styles.mobileSortSelectButton, key === sorting && styles.active)}
              onClick={() => {
                sort(key)
                accordionActions.current?.close()
              }}
              type="button"
            >
              <span>{t(getSortLabel(key))}</span>
              {key === sorting && <SVGIcon icon={SVGCheck} size="14px" />}
            </button>
          ))}
      </div>
    </AccordionV2>
  )
}
